/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import {
    CacheType,
    createObservableDataAction,
    IAction,
    IAny,
    IActionContext,
    IActionInput,
    ICreateActionContext,
    IGeneric
} from '@msdyn365-commerce/core';
import { OrgUnitLocation } from '@msdyn365-commerce/retail-proxy';
import { searchOrgUnitLocationsAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/OrgUnitsDataActions.g';

/**
 * Input for search-org-unit-locations data action.
 */
export class SearchOrgUnitLocationsInput implements IActionInput {
    public getCacheKey = () => 'SearchOrgUnitLocations';

    public getCacheObjectType = () => 'SearchOrgUnitLocations';

    public dataCacheType = (): CacheType => 'request';
}

/**
 * Creates the input required to make the retail api call.
 * @param inputData -- Input data.
 * @returns -- IActionInput.
 */
export const createSearchOrgUnitLocationsInputFunc = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return new SearchOrgUnitLocationsInput();
};

/**
 * Calls the Retail API and returns all the orgUnitLocations as array.
 * @param input - Input.
 * @param ctx - Context.
 * @returns - orgUnitLocations.
 */
export async function getSearchOrgUnitLocationsAction(
    input: SearchOrgUnitLocationsInput,
    context: IActionContext
): Promise<OrgUnitLocation[]> {
    const OrgUnitLocations = await searchOrgUnitLocationsAsync(
        {
            callerContext: context
        },
        {}
    );

    return OrgUnitLocations;
}

export const retailActionDataAction = createObservableDataAction({
    id: '@msdyn365-commerce-modules/retail-actions/search-org-unit-locations',
    action: <IAction<OrgUnitLocation[]>>getSearchOrgUnitLocationsAction,
    input: createSearchOrgUnitLocationsInputFunc
});

export default retailActionDataAction;
